import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import s from './style.module.scss';

const Saara = ({ setOnRendered }) => {
  const { currentCover } = useSelector((state) => state.templatesReducer);

  useEffect(() => {
    setOnRendered(true);
  });
  return (
    <>
      {currentCover && (
        <div className={s.c}>
          <div className="section-col">
            <div className="section">
              <div className="sub-section">
                <div className={s.c__top}>
                  <h1>
                    {currentCover.firstName} {currentCover.lastName}
                  </h1>
                  <div className={s.c__job}>{currentCover.jobTitle}</div>
                </div>
              </div>
            </div>
            <div className="section">
              <div className={s.top_contacts}>
                <div>
                  {currentCover.country.name}, {currentCover.city.name}
                </div>
                <div>
                  {currentCover.state && currentCover.state} {currentCover.zip && currentCover.zip}
                </div>
              </div>
            </div>
            <div className="section">
              <div className={s.main}>
                <div className={`${s.main__row} sub-section`}>
                  <div className={s.main__title}>
                    {currentCover.jobTitle} <span>{currentCover.date}</span>
                  </div>
                </div>

                {currentCover.greeting && (
                  <div className={`${s.main__row} sub-section`}>
                    <div className={s.main__text}>{currentCover.greeting}</div>
                  </div>
                )}

                {currentCover.openingParagraph && (
                  <div className={`${s.main__row} sub-section`}>
                    <div className={s.main__text}>{currentCover.openingParagraph}</div>
                  </div>
                )}

                {currentCover.secondParagraph && (
                  <div className={`${s.main__row} sub-section`}>
                    <div className={s.main__text}>{currentCover.secondParagraph}</div>
                  </div>
                )}

                {currentCover.thirdParagraph && (
                  <div className={`${s.main__row} sub-section`}>
                    <div className={s.main__text}>{currentCover.thirdParagraph}</div>
                  </div>
                )}

                {currentCover.signature && (
                  <div className={`${s.main__row} sub-section`}>
                    <div className={s.main__text}>{currentCover.signature}</div>
                  </div>
                )}
              </div>
            </div>
            <div className={s.contacts}>
              {currentCover.email && (
                <div className={`${s.contacts__item} ${s.contacts__text__mail}`}>
                  <div className={s.contacts__text}>{currentCover.email}</div>
                </div>
              )}

              <div className={`${s.contacts__item} ${s.contacts__text__state}`}>
                <div className={s.contacts__text}>
                  {currentCover.country.name}, {currentCover.city.name}
                  {currentCover.state && `, ${currentCover.state}`}
                  {currentCover.zip && `, ${currentCover.zip}`}
                </div>
              </div>
              {currentCover.phone && (
                <div className={`${s.contacts__item} ${s.contacts__text__phone}`}>
                  <div className={s.contacts__text}>{currentCover.phone}</div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

Saara.propTypes = {
  setOnRendered: PropTypes.func.isRequired,
};
export default Saara;
